import React from 'react'
import { IconProps } from '../../types/types'

const BrushIcon:React.FC<IconProps> = ({ size = 20, color = 'white' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_233_2927)">
        <path d="M7.91667 16.25V15H3.75C3.29167 15 2.875 14.8166 2.575 14.5083C2.26667 14.2083 2.08334 13.7916 2.08334 13.3333C2.08334 12.475 2.75 11.7583 3.59167 11.675C3.64167 11.6666 3.69167 11.6666 3.75 11.6666H16.25C16.3083 11.6666 16.3583 11.6666 16.4083 11.675C16.8083 11.7083 17.1583 11.8833 17.425 12.1583C17.7667 12.4916 17.95 12.9666 17.9083 13.4833C17.8333 14.3583 17.0417 15 16.1583 15H12.0833V16.25C12.0833 17.4 11.15 18.3333 10 18.3333C8.85 18.3333 7.91667 17.4 7.91667 16.25Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.8083 4.41663L16.4083 11.675C16.3583 11.6666 16.3083 11.6666 16.25 11.6666H3.75C3.69166 11.6666 3.64166 11.6666 3.59166 11.675L3.19166 4.41663C3.04166 2.94163 4.2 1.66663 5.675 1.66663H14.325C15.8 1.66663 16.9583 2.94163 16.8083 4.41663Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.65833 1.66663V5.83329" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10 1.66663V3.33329" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_233_2927">
        <rect width="20" height="20" fill={color} />
        </clipPath>
        </defs>
    </svg>
  )
}

export default BrushIcon